import { Pipe, PipeTransform } from 'ng-metadata/core';


/**
 * @ngdoc filter
 * @name mwTruncateHtml
 * @module mw.components.dataFormatting
 *
 * @param {string} [html] - The HTML which that will be truncated
 * @param {number} [length] - The length of which you want the HTML to be truncated to
 * @returns {string} - The truncated HTML
 *
 * @description
 * `mwTruncateHtml` truncates any HTML that to a specific length that is passed in
 */
@Pipe({
    name: 'mwTruncateHtml'
})
export class TruncateHtmlPipe implements PipeTransform {
    transform (html: string, length: number) {
        if (html) {
            return this.truncateHtml(html, length, true);
        } else {
            return '';
        }
    }

    getNextTag(htmlFragment) {
        let match = htmlFragment.match(/<(\/?)([\w-]+)/) || {};

        return {
            name: match[2],
            isClosing: !!match[1]
        };
    }

    removeLastInstance(array, item) {
        let index;

        for (index = array.length - 1; index >= 0; index--) {
            if (array[index] === item) {
                array.splice(index, 1);
                break;
            }
        }
    }

    truncateHtml(html, length, appendEllipsis) {
        let truncatedHtml = '';
        let truncatedTextLength = 0;
        let openTagNames = [];
        let isEncodingCharacter = false;
        let isWritingTag = false;
        let currentFragment;
        let currentCharacter;
        let currentTag;
        let currentCharacterIndex;

        if (typeof html !== 'string') return '';

        for (currentCharacterIndex = 0; currentCharacterIndex < html.length && truncatedTextLength < length; currentCharacterIndex++) {
            currentFragment = html.substring(currentCharacterIndex);
            currentCharacter = currentFragment[0];
            truncatedHtml += currentCharacter;

            if (currentCharacter === '&') {
                isEncodingCharacter = true;
            } else if (isEncodingCharacter && currentCharacter === ';') {
                isEncodingCharacter = false;
            }

            if (currentCharacter === '<') {
                isWritingTag = true;
                currentTag = this.getNextTag(currentFragment);

                if (!currentTag.isClosing) {
                    openTagNames.push(currentTag.name);
                } else {
                    this.removeLastInstance(openTagNames, currentTag.name);
                }
            }

            if (!isEncodingCharacter && !isWritingTag) {
                truncatedTextLength++;
            }

            if (isWritingTag && currentCharacter === '>') {
                isWritingTag = false;
            }
        }

        if (appendEllipsis && currentCharacterIndex < html.length) {
            truncatedHtml += '…';
        }

        while (currentTag = openTagNames.pop()) {
            truncatedHtml += '</' + currentTag + '>';
        }

        return truncatedHtml;
    }
}




// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/truncate-html.pipe.ts